import clsx from 'clsx'
import { htmlReactParse } from 'shared-code/html'
import { DealBarContext } from 'shared-components/contexts/DealBarContext'
import Linked from 'shared-components/service/Linked'
import Cart from 'shared-svg/Cart.svg'
import ArrowRightBird from 'shared-svg/ArrowRightBird.svg'
import styles from './DealCtaPill.module.css'
import { useCatalogEvent } from 'lib/analytics/catalog'
import { isCatalogEventName } from 'shared-code/app-events'

/**
 * The deal CTA rendered inline (next to the breadcrumbs) on DealHunt category/
 * product pages, replacing the standalone under-nav deal bar (which those pages
 * suppress via `layoutProps.hideDealBar`). Reuses the same `DealBarContext` data,
 * so live shows the real contextual wording and link; renders nothing until the
 * deal data resolves (mirrors the standalone bar's behaviour).
 */
const DealCtaPill: React.VFC<{ className?: string }> = ({ className }) => {
  const { dealbar } = DealBarContext.useContainer()
  const { track, scope } = useCatalogEvent()
  if (!dealbar) {
    return null
  }
  return (
    <Linked
      data-sel="db-link-el"
      className={clsx(styles.pill, className)}
      {...dealbar.pLink}
      onClick={() => {
        // Not every surface registers a deal-pill event (coverage hubs render no pill).
        const name = `${scope?.page_type ?? ''}_deal_pill_click`
        if (isCatalogEventName(name)) {
          track(name, { label: dealbar.label, destination_url: dealbar.pLink.href })
        }
      }}
      style={dealbar.color ? { backgroundColor: dealbar.color } : undefined}
    >
      <Cart className={styles.cart} />
      <span className={styles.label}>{htmlReactParse(dealbar.label)}</span>
      <ArrowRightBird className={styles.arrow} />
    </Linked>
  )
}

export default DealCtaPill
